import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { proxy, useSnapshot } from 'valtio';
import getStateManager from '../StateManager.js';
import { trackId } from '../Hooks/useTabController';

const emptyController = proxy({});

export function TabInfo({ className, zone_id, tab_id, controller }) {
  const { t } = useTranslation();
  const stateManager = getStateManager();
  // Snapshot: the zone name can change while the tab is open.
  const controllerSnapshot = useSnapshot(controller ?? emptyController);
  trackId(controllerSnapshot); // nothing else is read outside a zone

  // Get the actual zone name if zone_id is provided and controller exists
  let zoneName = undefined;
  if (zone_id && controller) {
    const parent = stateManager.getParent(controllerSnapshot, zone_id);
    if (parent && parent.name !== undefined) {
      zoneName = parent.name;
    }
  }

  const displayText = [zoneName !== undefined && zoneName, tab_id !== undefined && t(tab_id)]
    .filter(Boolean)
    .join(' · ');

  return <Typography className={className}>{displayText || null}</Typography>;
}
